import Table from "./Table";
import "@ingka/svg-icon/style.scss";
import "@ingka/button/style.scss";
import "@ingka/focus/style.scss";
import "@ingka/carousel/style.scss";
import Carousel from "@ingka/carousel";
import Message from "./Message";

// Function to create the column configuration
const getColumns = (label) => [
  {
    accessorKey: "label",
    header: label,
    size: 70,
    enableSorting: false,
  },
  {
    accessorKey: "value",
    header: "",
    size: 40,
    Cell: ({ cell, row }) => (
      <span style={{ color: row.original.valueColor }}>
        <b>{cell.getValue()}</b>
      </span>
    ),
  },
]

export default function CarouselTable({ data }) {
  return <Carousel controlBtnType="primary" id="carousel-table" hasNoScrollbar>
      {data.map(({ label, row }, i) => {
        return row && (
        <Message
          key={`${label}-${i}`}
          title={<Table columns={getColumns(label)} data={row} />}
        />
      )})}
    </Carousel>
}
